import axios from "axios";
import Vue from "vue";

export const state = {
  pettyRequests: [],
  allReqPettyCash: [],
  approvedPettyCash: [],
  pettyCash: [],
  save_status: false,
  successConfirm: false,
};
export const getters = {
  getPettyRequests: (state) => state.pettyRequests.data,
  getApprovedPettyCash: (state) => state.approvedPettyCash.data,
  getAllReqPettyCash: (state) => state.allReqPettyCash,
  SaveStatus: (state) => state.save_status,
  getSuccessConfirm: (state) => state.successConfirm,
  getPettyCash: (state) => state.pettyCash.data,
};

export const mutations = {
  SET_PETTYREQUESTS(state, newValue) {
    state.pettyRequests = newValue;
  },
  SET_PETTYCASH(state, newValue) {
    state.pettyCash = newValue;
  },
  SET_ALLREQUEST(state, newValue) {
    state.allReqPettyCash = newValue;
  },
  SET_APPROVEDPETTY(state, newValue) {
    state.approvedPettyCash = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  SET_SAVE_CONFIRM(state, newValue) {
    state.successConfirm = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  resetSuccessConfirm({ commit }) {
    commit("SET_SAVE_CONFIRM", false);
  },
  submitPettyRequest({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("petty_cash", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Petty Cash Request Sent Successfully",
        };
        dispatch("fetchPettyRequests");
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
        commit("SET_SAVE_CONFIRM", true);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Sending Request",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  pettyCashPay({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("petty_cash/pay", payload)
      .then((response) => {
        const message =
          response.data.msg == "No Account Set"
            ? {
                type: "error",
                title: "<b>Error Notifications</b>",
                message: "No Petty Cash Accout set, or has less credit on it",
              }
            : {
                type: "success",
                title: "<b>Success Notifications</b>",
                message: "Payment Was Successfully",
              };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
        history.back();
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Paying Request",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  pettyCashAction({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("petty_cash/action", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Request Was Successfully",
        };
        dispatch("fetchAllRequestPettyCash");
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Sending Request",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  fetchPettyCash({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("petty_cash/" + payload.id)
      .then((response) => {
        commit("SET_PETTYCASH", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Sending Request",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  fetchPettyRequests({ commit }) {
    axios.get("petty_cash").then((response) => {
      commit("SET_PETTYREQUESTS", response.data);
    });
  },

  fetchAllRequestPettyCash({ commit }) {
    axios.get("petty_all").then((response) => {
      commit("SET_ALLREQUEST", response.data);
    });
  },
};
